export const ROLES = {
    TEACHER: "teacher",
    STUDENT: "student",
}
